import React from 'react';
import getContent from '../../../lib/dictionaryFetcher';

const RedirectBanner = () => {
  return (
    <div className="redirect-banner">
      <h4>{getContent('merchanthub', 'redirectBanner.text')}</h4>
    </div>
  );
};

export default RedirectBanner;
